import { Trophy, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

interface HeaderPointsDisplayProps {
  level: number;
  points: number;
  /** @deprecated kept for back-compat; streaks were removed. */
  streakDays?: number;
  className?: string;
}

export function HeaderPointsDisplay({ level, points, className }: HeaderPointsDisplayProps) {
  const navigate = useNavigate();
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => navigate('/my-progress')}
      className={cn(
        "flex items-center gap-3 px-3 py-2 h-auto hover:bg-primary/10 transition-all",
        className
      )}
    >
      <div className="flex items-center gap-1.5 px-2 py-1 bg-primary/20 rounded-full">
        <Trophy className="h-3.5 w-3.5 text-primary" />
        <span className="text-xs font-bold text-primary">Lvl {level}</span>
      </div>
      <div className="flex items-center gap-1">
        <Star className="h-3.5 w-3.5 text-yellow-500" />
        <span className="text-xs font-semibold">{points}</span>
      </div>
    </Button>
  );
}

